import axios from "axios";
import { BACKEND_URL } from "./apiConfig";
import { log } from "../utils/logger";
import { getAuthToken, getAuthHeader, getPublicHeader } from "./authUtils";

type GetActivitiesOpts = {
    subscriberId?: number | string;
    isPublicView?: boolean;
    uuid?: string;
};

export async function getActivities(
    opts: GetActivitiesOpts
): Promise<any> {
    const { isPublicView, uuid } = opts;

    if(!isPublicView){
        // Normal fetch
        const token = getAuthToken();
        if (typeof uuid !== "string" || uuid.trim() === "" || uuid === "false") {
            throw new Error("UUID must be a non-empty string.");
        }

        try {
            const response = await axios.get(`${BACKEND_URL}/eshop/items/activities?uuid=${uuid}`, {
                headers: getAuthHeader(token),
            });
            log("[Fetch] activities:", response.data);
            return response.data;
        } catch (error: any) {
            throw new Error(`Error ${error.response.status}: ${error.response.statusText}`);
        }
    }else{
        // Fetch in public catalog
        try {
            const response = await axios.get(`${BACKEND_URL}/eshop/items/activities?uuid=${uuid}`, {
                headers: getPublicHeader(),
            });
            log("[Fetch] activities (public):", response.data);
            return response.data;
        } catch (error: any) {
            throw new Error(`Error ${error.response.status}: ${error.response.statusText}`);
        }
    }

}

export interface ActivityQuery {
    activity_id: number;
    firstname: string;
    lastname: string;
    company: string;
    email: string;
    phone_number: string;
    people_count: number;
    budget: number;
    date: string;
    note: string
} 
interface SendActivityProps {
    activity: ActivityQuery;
    uuid?: string;

}

export async function sendActivity({ activity, uuid }: SendActivityProps){
    // Get JWT token
    const token = getAuthToken();

    // Make sure uuid exists
    if (typeof uuid !== "string" || uuid.trim() === "" || uuid === "false") {
        throw new Error("UUID must be a non-empty string.");
    }

    try {
        const response = await axios.post(
            `${BACKEND_URL}/eshop/items/activities/register/`,
            activity,
            {
                params: { uuid },
                headers: {
                    ...getAuthHeader(token),
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error: any) {
        throw new Error(`Error ${error.response.status}: ${error.response.statusText}`);
    }

}
